/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { StatesByCountry } from "~/constants";
import { GetValidLocationsResponse, PayoutCountry } from "~/features/myAccount/types";

const transformToComplianceCountries = (validLocationsResponse: GetValidLocationsResponse["result"]) => {
  const countries: Record<string, PayoutCountry> = {};

  Object.keys(validLocationsResponse.countries).forEach((countryCode) => {
    countries[countryCode] = {
      countryCode,
    };

    const validStateCodes = StatesByCountry[countryCode as keyof typeof StatesByCountry];

    if (validStateCodes) {
      const states: Record<string, string> = {};

      Object.entries(validLocationsResponse.states).forEach(([stateCode, stateName]) => {
        if (validStateCodes.includes(stateCode)) {
          states[stateCode] = stateName;
        }
      });

      countries[countryCode].states = states;
    }
  });

  return countries;
};

export default transformToComplianceCountries;
